import Upload from "./Upload";
import Wrapper from "./Wrapper";
import SectionWrapper from "./SectionIngestWrapper";

export default {
  Upload,
  Wrapper,
  SectionWrapper
};
